<template>
  <div class="row">
    <!--    <div class="col">-->
    <!--            <div class="row">-->
    <!--              <div class="col-4 lbl">-->
    <!--                <label>Genre de fichier :</label>-->
    <!--              </div>-->
    <!--              <div class="col">-->
    <!--                <Dropdown class="dropdown-height"-->
    <!--                          v-model="genreFichier"-->
    <!--                          :options="genreFichierLibelles"-->
    <!--                          optionValue="valeur"-->
    <!--                          optionLabel="texte"-->
    <!--                          scrollHeight="205px"-->
    <!--                          :showClear="true"/>-->
    <!--              </div>-->
    <!--            </div>-->
    <!--    </div>-->
    <div class="col border-white">
      <div class="row">
        <div class="col"></div>
      </div>
      <div class="row">
        <div class="col">
          <Button label="Localisation" v-on:click="localisation"/>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Button label="Regroupement" v-on:click="regroupement"/>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Button label="Véhicules" v-on:click="vehicules"/>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Button label="Endroit" v-on:click="endroit"/>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <!--    <div class="col">-->
    <!--      <Button @click="rechercher"> Rechercher</Button>-->
    <!--    </div>-->
    <!--    <div class="col">-->
    <!--      <Button @click="effacerCriteres"> Effacer critères</Button>-->
    <!--    </div>-->
    <!--    <div class="col">-->
    <!--      <Button @click="ajouterGenreFichier"> Ajouter</Button>-->
    <!--    </div>-->
    <div class="col">
      <Button @click="fermer"> Fermer</Button>
    </div>
  </div>
</template>

<script>
export default {
  name: "CriteresRechercheGenreFrichier",
  emits: ['rechercher', 'fermer'],
  data() {
    return {
      genreFichier: null,
      genreFichierLibelles: [],
      critereRechercheGenreFichier: {},
    }
  },
  mounted() {
    // this.$store.dispatch('dossier/rechercherDefaut48HeuresAction')
    //     .then((res) => {
    //       this.assignerListe(res.data.genreFichierDecision);
    //     });
    // this.$store.dispatch("dossier/obtenirGenreFichierAction").then((res) => {
    //   this.genreFichier = res.data.genreFichier;
    // });
  },
  methods: {
    assignerListe(genreFichierDecision) {
      this.genreFichierLibelles = genreFichierDecision.genreFichier.libelles;
    },
    localisation() {
      this.$router.push({name: "classementLocalisation"});
    },
    regroupement() {
      this.$router.push({name: "rechercherRegroupement"});
    },
    vehicules() {
      this.$router.push({name: "classementVehiculesPilotage"});
    },
    endroit() {
      this.$router.push({name: "rechercherEndroit"});
    },
    rechercher() {
      this.critereRechercheGenreFichier.genreFichier = this.genreFichier;
      this.$emit('rechercher', this.critereRechercheGenreFichier);
    },
    effacerCriteres() {
      this.genreFichier = null;
    },
    ajouterGenreFichier() {
      this.$router.push({name: "ajouterGenreFichier"});
    },
    fermer() {
      this.$emit('fermer');
    }
  },
}
</script>
